<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <Avatar :src="userAvatar"/>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="clear">清理缓存 </DropdownItem>
        <DropdownItem name="updatePwd">修改密码</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <div>
<!--      <Modal-->
<!--        v-model="modal"-->
<!--        title="修改密码"-->
<!--        @on-ok="ok"-->
<!--        :loading="loading"-->
<!--        >-->
<!--        <Form ref="userForm" :model="form" :label-width="80" :rules="ruleValidate">-->

<!--          <FormItem label="原密码" prop="oldPassword">-->
<!--            <Input v-model="form.oldPassword" type="password"></Input>-->
<!--          </FormItem>-->
<!--          <FormItem label="新密码" prop="newPassword">-->
<!--            <Input v-model="form.newPassword" type="password"></Input>-->
<!--          </FormItem>-->
<!--          <FormItem label="密码确认" prop="newAgainPwd">-->
<!--            <Input v-model="form.newAgainPwd" type="password"></Input>-->
<!--          </FormItem>-->
<!--        </Form>-->
<!--      </Modal>-->

      <Modal v-model="modal" width="360">
        <template #header>
          <p style="text-align:center;font-size: 18px">
            <span>修改密码</span>
            <hr style="border: 0;border-top: 1px solid #d0d0d5;margin-top: 5%">
            <br>
          </p>
        </template>
        <div style="text-align:center">
          <Form ref="userForm" :model="form" :label-width="80" :rules="ruleValidate">

            <FormItem label="原密码" prop="oldPassword">
              <Input v-model="form.oldPassword" type="password"></Input>
            </FormItem>
            <FormItem label="新密码" prop="newPassword">
              <Input v-model="form.newPassword" type="password"></Input>
            </FormItem>
            <FormItem label="密码确认" prop="newAgainPwd">
              <Input v-model="form.newAgainPwd" type="password"></Input>
            </FormItem>
          </Form>
        </div>
        <template #footer>
          <div slot="footer">
            <Button type="text" size="large" @click="cancel">取消</Button>
            <Button type="primary" size="large" @click="ok">确定</Button>
          </div>
        </template>

      </Modal>
    </div>
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
import md5 from 'js-md5'
export default {
  name: 'User',
  props: {
    userAvatar: {
      type: String,
      default: 'https://i.loli.net/2017/08/21/599a521472424.jpg'
    }
  },
  data () {
    return {
      modal: false,
      loading: true,
      form: {
        oldPassword: '',
        newPassword: '',
        newAgainPwd: ''
      },
      ruleValidate: {
        oldPassword: [
          { required: true, message: '原密码不允许为空', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '新密码不允许为空', trigger: 'blur' }
        ],
        newAgainPwd: [
          { required: true, message: '密码确认不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    this.resetForm()
  },
  methods: {
    ...mapActions([
      'handleLogOut',
      'getUserInfo'
    ]),
    resetForm () {
      this.form = {
        oldPassword: '',
        newPassword: '',
        newAgainPwd: '',
        account: ''
      }
    },
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.handleLogOut().then(() => {
            this.$router.push({
              name: 'login'
            })
          })
          break
        case 'clear':
          sessionStorage.clear()
          break
        case 'updatePwd':
          this.modal = true
          this.resetForm()
          break
      }
    },
    cancel () {
      this.modal = false
    },
    ok () {
      this.$refs.userForm.validate((valid) => {
        if (this.form.newPassword !== this.form.newAgainPwd) {
          this.$Message.error('两次密码输入不一致')
          return
        }
        if (valid) {
          this.getUserInfo().then(res => {
            this.form.account = res.account
            let param = {
              account: this.form.account,
              type: 1, // 管理平台账户
              password: md5(this.form.newPassword),
              oldPassword: md5(this.form.oldPassword)
            }
            this.P('admin/userAuth/modifyPassword', param).then(data => {
              if (data) {
                this.$Message.success('密码修改成功')
                this.modal = false
              }
            })
          })
        }
      })
    }
  }
}
</script>
